import { z } from 'zod';

/**
 * Versão atual da Política de Privacidade e Cookies do Gestão Leve (#378).
 * Qualquer alteração material nesta versão invalida o consentimento local anterior,
 * exibindo o banner novamente para coleta conforme ANPD e LGPD art. 8º e 9º.
 */
export const VERSAO_ATUAL_POLITICA_COOKIES = '2026-10-18';

/**
 * Origens permitidas de coleta ou atualização de consentimento de cookies.
 */
export const ORIGENS_CONSENTIMENTO_COOKIES = [
  'banner',
  'perfil',
  'rodape',
  'privacidade',
] as const;
export type OrigemConsentimentoCookies = (typeof ORIGENS_CONSENTIMENTO_COOKIES)[number];

/**
 * Categorias de cookies e rastreadores (LGPD arts. 7º I e 8º, Guia ANPD 2022):
 * - necessarios: tokens de sessão e autenticação (sempre true, obrigatórios para o app)
 * - medicao: GA4 e CloudWatch RUM (opcionais, default false)
 * - publicidade: Meta Pixel e Meta Conversions API (opcionais, default false)
 */
export const categoriasConsentimentoCookiesSchema = z.object({
  necessarios: z.literal(true),
  medicao: z.boolean(),
  publicidade: z.boolean(),
});
export type CategoriasConsentimentoCookies = z.infer<typeof categoriasConsentimentoCookiesSchema>;

/**
 * Schema para payload de salvar/atualizar consentimento via API (PUT /api/membros/me/consentimento).
 */
export const salvarConsentimentoCookiesSchema = z.object({
  versaoPolitica: z.string().min(1, 'Versão da política é obrigatória'),
  categorias: categoriasConsentimentoCookiesSchema,
  origem: z.enum(ORIGENS_CONSENTIMENTO_COOKIES, {
    errorMap: () => ({ message: 'Origem de consentimento inválida' }),
  }),
});
export type SalvarConsentimentoCookiesInput = z.infer<typeof salvarConsentimentoCookiesSchema>;

/**
 * Schema para persistência local do consentimento no dispositivo (localStorage: ERPLIGHT_COOKIE_CONSENT).
 */
export const consentimentoCookiesLocalSchema = z.object({
  versaoPolitica: z.string().min(1),
  categorias: categoriasConsentimentoCookiesSchema,
  data: z.string().min(1),
  origem: z.enum(ORIGENS_CONSENTIMENTO_COOKIES),
});
export type ConsentimentoCookiesLocal = z.infer<typeof consentimentoCookiesLocalSchema>;

/**
 * Estrutura de resposta de auditoria de consentimento retornada pela API.
 */
export interface ConsentimentoCookiesResponse {
  tenantId?: string;
  cognitoSub?: string;
  versaoPolitica: string;
  categorias: CategoriasConsentimentoCookies;
  data: string;
  origem: OrigemConsentimentoCookies;
  createdAt?: string;
  updatedAt?: string;
}
